import React, { useState } from "react";
import aside from "../Images/Login-img.png";
import "./CSS/login.css";
import { BLACK, GRAY_DARK, GRAY_DARL, GRAY_LIGHT } from "../styles/color";
import GlobalInput from "../components/CustomInput";

import {
  validateEmail,
  validateName,
  validatePassword,
  validatePhone,
  validatePinCode,
} from "../Utils/Validation";
import CustomButton from "../components/CustomButton";
import google from "../Images/google.png";
import facebook from "../Images/facebook.png";
import apple from "../Images/apple.png";
import { Grid, Stack } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import {
  auth,
  provider,
  facebookProvider,
} from "../ServiceModule/Firebase";
import {
  signInWithPopup,
  getAuth,
  sendEmailVerification
} from "firebase/auth";


import { useDispatch, useSelector } from "react-redux";
import { registerUserWithRoleUser, verifyUserWithEmail, UserUpdate, UserUpdateWithUserRole, loginUser } from "../Features/Auth/AuthSlice";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  Dialog,
  DialogContent,
  Typography,
  CircularProgress,
  Button,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { createUserWithEmailAndPassword } from "firebase/auth";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { useThemeColors } from "../Context/Theme";
import { useGetAPIWithoutTokenQuery } from "../Api/api";
import { READ_ONE_EVENT } from "../Api/apiConstant";
import { formatPhoneNumber, isMobile } from "../global/helpers";
import {
  usePostAPIWithOutTokenMutation
} from "../Api/api";
import { UPDATE_USER_WITH_USER_ROLE } from "../Api/apiConstant";
import HomeButton from "../components/HomeButton";
import encryptJSON from "../ServiceModule/Encrypt";
import { isProdEnv, secretEncryptionKey } from "../ServiceModule/Service";
import { storeLoggedIn, storeRoleName, storeToken, storeUser, storeUserId, storeRoleId } from "./LoginUtility";
const Register = () => {
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    buttonTextColor,
    backgroundColor,
    logo,
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading,
  } = useThemeColors();

  const [isValidName, setIsValidName] = useState(true);
  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [validPhone, setValidPhone] = useState(true);
  const [pincode, setPincode] = useState("");
  const [isValidPinCode, setIsValidPinCode] = useState(true);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isValidPassword, setIsValidPassword] = useState(true);
  const [isChecked, setIsChecked] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [nameprovider, setnameProvider] = useState("");
  const [hasUpperCase, setHasUpperCase] = useState(false);
  const [hasLowerCase, setHasLowerCase] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasSpecialChar, setHasSpecialChar] = useState(false);
  const [isValidLength, setIsValidLength] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isVerificationLoading, setIsVerificationLoading] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [updateUser] = usePostAPIWithOutTokenMutation();

  const auth = getAuth();


  const dispatch = useDispatch();
  const navigate = useNavigate();
  const eventName = sessionStorage.getItem("eventName");
  const roleId = 4;
  const eventId = sessionStorage.getItem("event_id");

  const firstName = fullName?.split(" ")[0];
  const lastName = fullName?.split(" ")[1];


  const { data, isLoading, isError, isSuccess, error } =
    useGetAPIWithoutTokenQuery(`${READ_ONE_EVENT}${eventId}`);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const areFieldsFilled = () => {
    return email && password && fullName && phoneNumber && pincode;
  };

  const handleEmailChange = (e) => {
    const emailId = e.target.value.trimStart();

    setEmail(emailId);
    setIsValidEmail(validateEmail(emailId));

  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value.trimStart();

    // Remove spaces from the input
    const sanitizedPassword = newPassword.replace(/\s/g, "");
    setPassword(sanitizedPassword);

    // Password validations
    const hasUpperCase = /[A-Z]/.test(sanitizedPassword);
    const hasLowerCase = /[a-z]/.test(sanitizedPassword);
    const hasNumber = /[0-9]/.test(sanitizedPassword);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(sanitizedPassword);
    const isValidLength = sanitizedPassword.length >= 8 && sanitizedPassword.length <= 64;

    // Update state for individual checks
    setHasUpperCase(hasUpperCase);
    setHasLowerCase(hasLowerCase);
    setHasNumber(hasNumber);
    setHasSpecialChar(hasSpecialChar);
    setIsValidLength(isValidLength);

    // Compute overall password validity
    const isValidPassword =
      hasLowerCase && hasUpperCase && hasNumber && hasSpecialChar && isValidLength;
    setIsValidPassword(isValidPassword);
  };

  const handleLoginResponse = async (loginResponsePromise) => {
    try {
      const loginResponse = await loginResponsePromise;

      if (loginResponse && loginResponse?.status === true) {
        setLoggedIn(true);

        const roleName = loginResponse?.user?.role_name;
        const eventName = sessionStorage.getItem("eventName");

        storeLoggedIn("true");
        storeUserId(loginResponse?.user?.user_id);
        storeRoleId(loginResponse?.user?.role_id);
        storeUser(JSON.stringify(loginResponse?.user));
        storeRoleName(roleName);
        storeToken(loginResponse?.user?.token);
        sessionStorage.setItem("cartId", loginResponse?.user?.cart_id);
        toast.success("Login successful!", {
          autoClose: 1000,
          onClose: () => navigate(`/events/${eventName}`),
        });
      } else {
        toast.error("Invalid Credential");
      }
    } catch (error) {
      console.error("Error in login:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  //   const handleVerifyGoogle = async (email, username, providerName) => {
  //     const nameParts = username.trim().split(" ");
  //     const first_name = nameParts[0] || "";
  //     const last_name = nameParts.slice(1).join(" ") || "";
  //     const registerResponse = dispatch(
  //       registerUserWithRoleUser({
  //         user_email: email.toLowerCase(),
  //         user_password: password,
  //         user_name: username,
  //         first_name: first_name,
  //         last_name: last_name,
  //         role_id: roleId,
  //         provider_name: providerName,
  //       })
  //     ).unwrap();

  //     if (
  //       registerResponse &&
  //       registerResponse.meta.requestStatus === "fulfilled"
  //     ) {

  //       handleCloseDialog();
  //       toast.success("Registration Successful!");
  //       const loginResponse = dispatch(
  //         loginUser({
  //           user_email: email.toLowerCase(),
  //           provider_name: providerName,
  //         })
  //       );
  //       handleLoginResponse(loginResponse);
  //     } else {
  //       toast.error("Registration Failed");
  //     }
  //   };

  const handleVerifyGoogle = async (email, username, providerName) => {
    try {
      const nameParts = username.trim().split(" ");
      const first_name = nameParts[0] || "";
      const last_name = nameParts.slice(1).join(" ") || "";

      const registerResponse = await dispatch(
        registerUserWithRoleUser({
          user_email: email.toLowerCase(),
          user_password: password,
          user_name: username,
          role_id: roleId,
          provider_name: providerName,
          first_name: first_name,
          last_name: last_name,
        })
      ).unwrap();

      if (registerResponse?.status) {

        const loginResponse = await dispatch(
          loginUser({
            user_email: email.toLowerCase(),
            provider_name: providerName,
            event_id: eventId,
          })
        ).unwrap();

        handleLoginResponse(loginResponse);
      } else {
        toast.error("Registration Failed");
      }
    } catch (error) {
      console.error("Error during registration:", error);
      toast.error("Error during registration.");
    }
  };

  const handleUserVerification = async (email) => {

    try {
      const response = await dispatch(
        verifyUserWithEmail({
          user_email: email.toLowerCase(),
        })
      );
      if (response && response.payload.status === true) {
        toast.error("Email already registered");

        return true;
      }
      return false;
    } catch (error) {
      console.error("Error during verification:", error);
      toast.error("An error occurred during verification");
      return false;
    }
  };

  // Reusable function for handling OAuth logins

  const handleVerification = async (email) => {
    try {
      const action = verifyUserWithEmail({ user_email: email.toLowerCase() });
      const response = await dispatch(action);
      return response?.payload?.status === false;
    } catch (error) {
      console.error("Error during verification:", error);
      toast.error("An error occurred during verification");
      return false;
    }
  };

  const handleOAuthLogin = async (provider, providerName) => {
    try {
      const result = await signInWithPopup(auth, provider);
      ;


      const email = result.user.email;
      const username = result.user.displayName;
      const provider_name = result.providerId;
      setEmail(email);
      setFullName(username);
      setnameProvider(provider_name);
      const isRegistered = await handleVerification(email);

      if (!isRegistered) {
        // If user is registered, just login
        const loginResponse = dispatch(
          loginUser({
            user_email: email.toLowerCase(),
            provider_name: providerName,
            event_id: eventId,
          })
        ).unwrap()
        handleLoginResponse(loginResponse);

      } else {
        // If user is not registered, register and then login
        await handleVerifyGoogle(email, username, provider_name);
      }

    } catch (error) {
      if (
        error.message === "Firebase: Error (auth/cancelled-popup-request)." ||
        error.message === "Firebase: Error (auth/popup-closed-by-user)."
      ) {
        return;
      }
      toast.error(`Error during ${providerName} login`);
      console.error(`Error during ${providerName} login:`, error);
    }
  };

  // Google login handler
  const handleGoogleLogin = () => {
    handleOAuthLogin(provider, "google.com");
  };

  // Facebook login handler

  const handleOAuthLoginFacebook = async (provider, providerName) => {
    try {
      const result = await signInWithPopup(auth, provider);



      const email = result._tokenResponse.email;
      const username = result._tokenResponse.displayName;
      const provider_name = result.providerId;
      setEmail(email);
      setFullName(username);
      setnameProvider(provider_name);
      const isRegistered = await handleUserVerification(email);

      if (!isRegistered) {


        await handleVerifyGoogle(email, username, provider_name);

      }
      else {
        // If user is already registered, proceed to login
        const loginResponse = dispatch(

          loginUser({
            user_email: email.toLowerCase(),
            provider_name: providerName,
            event_id: eventId,

          })
        );
        handleLoginResponse(loginResponse);
      }

    } catch (error) {
      if (
        error.message === "Firebase: Error (auth/cancelled-popup-request)." ||
        error.message === "Firebase: Error (auth/popup-closed-by-user)."
      ) {
        return;
      }
      console.error(`Error during ${providerName} login:`, error);
    }
  };

  const onFacebookButtonPress = () => {
    handleOAuthLoginFacebook(facebookProvider, "facebook.com");
  };

  const validatePhoneInput = (e) => {
    let input = e.target.value;
    let numericInput = input.replace(/\D/g, "");

    if (numericInput.startsWith("0")) {
      setValidPhone(false);
      return;
    }

    if (numericInput.length > 10) {
      numericInput = numericInput.slice(0, 10);
    }

    const isValid = validatePhone(numericInput);
    setValidPhone(isValid);
    setPhoneNumber(numericInput);


  };


  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    // Check required fields
    if (!email || !password || !fullName || !phoneNumber || !pincode) {
      toast.error("Please fill in all required fields");
      return;
    }
    if (!isValidEmail) {
      toast.error("Please enter a valid email address");
      return;
    }
    // Check terms and conditions
    if (!isChecked) {
      toast.error("Please agree to the Terms and Conditions");
      return;
    }

    const isRegistered = await handleUserVerification(email);
    if (isRegistered) {
      return;
    }

    try {
      const registerResponse = dispatch(
        registerUserWithRoleUser({
          user_email: email.toLowerCase(),
          user_password: password.trim(),
          user_name: fullName,
          first_name: firstName,
          last_name: lastName,
          phone_number: phoneNumber,
          role_id: roleId,
          provider_name: nameprovider,
          zip_code: pincode,
          is_verifiy: false,
          eventName: eventName,
        })
      );
      const canSendEmail = registerResponse?.payload?.data?.can_send_email;
      if (canSendEmail) {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        await sendEmailVerification(userCredential.user);

        const intervalId = setInterval(async () => {
          await userCredential.user.reload();
          if (userCredential.user.emailVerified) {
            clearInterval(intervalId);
            toast.success("Registration successful. A verification email has been sent to the provided email address.");
            navigate(`/events/${eventName}/login`);
          }
        }, 3000);
      } else {
        toast.success("Registration successful. A verification email has been sent to the provided email address.");
        setTimeout(() => {
          navigate(`/events/${eventName}/login`);
        }, 5000);
      }
    } catch (error) {
      // Error handling
      if (error.code === "auth/email-already-in-use") {
        toast.error("That email address is already in use!");
      } else if (error.code === "auth/invalid-email") {
        toast.error("That email address is invalid!");
      } else {
        console.error("Error during registration:", error);
      }
    }
  };


  return (
    <React.Fragment>
      <ToastContainer limit={1} autoClose={2000} />
      <Dialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        PaperProps={{
          style: {
            width: "350px",
            maxWidth: "90%",
            borderRadius: "20px",
            border: "1px solid #D9D9D9",
          },
        }}
      >
        <DialogContent style={{ textAlign: "center" }}>
          {isVerificationLoading ? (
            <>
              <CircularProgress sx={{ color: "red", marginBottom: "1rem" }} />
              <Stack spacing={1}>
                <Typography variant="body1">
                  Verification email sent.
                </Typography>
                <Typography variant="body1">
                  Please verify your email to countinue.
                </Typography>
              </Stack>
            </>
          ) : (
            <>
              <CheckCircleIcon
                style={{
                  fontSize: "3rem",
                  color: "green",
                  marginBottom: "1rem",
                }}
              />
              <Typography variant="body1">Email verified successfully!</Typography>
            </>
          )}
        </DialogContent>
      </Dialog>
      <section className="" style={{ maxHeight: "100vh" }}>
        <div className="container-fluid">
          <div className="row vh-100">
            {/* Left side with Image */}
            <div class="col-sm-6 px-0 py-0 m-0 d-none d-sm-block position-relative">
              <img
                src={aside}
                alt="Login image"
                className="w-100 vh-100"
                style={{
                  objectFit: "cover",
                  objectPosition: "left",
                  margin: "0",
                  overflow: "hidden",

                }}
              />
              <div className="overlay-content" style={{ width: "100%" }}>
                <img
                  src={data?.event_img_path ? data?.event_img_path : aside}
                  alt="Login image"
                  className="w-100 vh-100"
                  style={{
                    objectFit: "cover",
                    objectPosition: "left",
                    margin: "0",
                    overflow: "hidden",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                  }}
                ></div>
              </div>
              <div className="overlay-content" style={{ width: "100%" }}>
                <img
                  src={logo}
                  alt="Logo"
                  className="mb-5"
                  width={218}
                  height={142}
                />
                <p
                  style={{ fontSize: fontSizeHeading || "30px", fontWeight: fontWeightHeading || "700", fontFamily: fontFamilyHeading }}
                  className="heading"
                >
                  Welcome to ORDER THAT
                </p>
                <p
                  style={{
                    fontSize: fontSize || "19px",
                    fontWeight: fontWeight || "500",
                    textAlign: "center",
                    fontFamily
                  }}
                >
                  You're Tailgate Ready with Order That
                </p>
              </div>
            </div>

            {/* Right side with Form */}

            <div
              className="col-sm-12 col-md-6 d-flex flex-column align-items-center text-black"
              style={{
                padding: "35px",
                maxHeight: "100%",
                overflowY: "auto",
                display: "flex",
                alignItems: "center",

              }}
            >
              <form
                style={{
                  width: "100%",
                  maxWidth: "33rem",
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <p
                    className="login-text fw-bold"
                    style={{ color: "black", fontSize: isMobile() ? "18px" : "24px" }}
                  >
                    Create your account
                  </p>
                  <HomeButton text="Home" />
                </div>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <GlobalInput
                      type="text"
                      label="Full Name"
                      value={fullName}
                      onChange={(e) => {
                        const input = e.target.value.trimStart();

                        const sanitizedInput = input.replace(
                          /[^a-zA-Z0-9\s]/g,
                          ""
                        )
                        setFullName(sanitizedInput);
                      }}
                      placeholder="Enter name"
                      required
                      width={"100%"}
                      className={!isValidName}
                      validationMessage={
                        !isValidName ? "Please enter name." : ""
                      }
                      onBlur={(e) => {
                        setIsValidName(validateName(e.target.value.trimStart()));
                      }}
                      style={{ borderColor: !isValidName ? "red" : "" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <GlobalInput
                      type="email"
                      label="Email "
                      value={email}
                      required
                      onChange={handleEmailChange}
                      placeholder="Enter email  "
                      className={!isValidEmail}
                      validationMessage={
                        !isValidEmail
                          ? "Please enter a valid email address."
                          : ""
                      }
                      width={"100%"}
                      onBlur={(e) => {
                        setIsValidEmail(validateEmail(e.target.value));
                      }}
                      style={{ borderColor: !isValidEmail ? "red" : "" }}

                    />

                  </Grid>
                  <Grid item xs={12} md={6}>

                    <GlobalInput
                      label="Phone Number"
                      value={phoneNumber?.length > 0 ? formatPhoneNumber(phoneNumber) : phoneNumber}
                      onChange={validatePhoneInput}
                      placeholder="Enter Phone number"
                      className={!validPhone}
                      validationMessage={
                        !validPhone
                          ? "Please enter a valid Phone Number."
                          : ""
                      }
                      minLength={12}
                      maxLength={12}
                      required
                      width={"100%"}
                      onBlur={() => {
                        const isValid = validatePhone(phoneNumber);
                        setValidPhone(isValid);
                      }}
                      style={{ borderColor: !validPhone ? "red" : "" }}

                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <GlobalInput
                      type={showPassword ? "text" : "password"}
                      label="Password"
                      value={password}
                      onChange={handlePasswordChange}
                      endIcon={
                        showPassword ? (
                          <RemoveRedEyeOutlinedIcon
                            onClick={() => setShowPassword(!showPassword)}
                            style={{ cursor: "pointer", color: "grey" }}
                          />

                        ) : (
                          <VisibilityOffOutlinedIcon
                            onClick={() => setShowPassword(!showPassword)}
                            style={{ cursor: "pointer", color: "grey" }}
                          />

                        )
                      }
                      placeholder="Enter password"
                      className={!isValidPassword ? "is-invalid" : ""}

                      required
                      width={"100%"}
                      style={{
                        borderColor: !isValidPassword ? "red !important" : "",
                      }}
                    />
                    {password && !(hasLowerCase && hasUpperCase && hasNumber && hasSpecialChar && isValidLength) && (
                      <p className="text-secondary mt-1">
                        <span>Password must contains</span>
                        <ul style={{ paddingLeft: "15px", marginBottom: "0px !important" }}>
                          <li style={{
                            fontSize: "12px"
                          }} className={hasNumber ? "text-success" : "text-danger"}>
                            At least 1 number (0...9)
                          </li>
                          <li style={{
                            fontSize: "12px"
                          }} className={isValidLength ? "text-success" : "text-danger"}>
                            Between 8 to 64 characters in length.
                          </li>
                          <li style={{
                            fontSize: "12px"
                          }} className={hasLowerCase ? "text-success" : "text-danger"}>
                            At least 1 lowercase letter (a...z)
                          </li>
                          <li style={{
                            fontSize: "12px"
                          }} className={hasUpperCase ? "text-success" : "text-danger"}>
                            At least 1 uppercase letter (A...Z)
                          </li>


                          <li style={{
                            fontSize: "12px"
                          }} className={hasSpecialChar ? "text-success" : "text-danger"}>
                            At least 1 special symbol (!...&)
                          </li>

                        </ul>
                      </p>
                    )}
                  </Grid>
                  {/* </div> */}
                  <Grid item xs={12} md={6}>
                    <GlobalInput
                      type="number"
                      label="ZIP"
                      placeholder="ZIP code"
                      value={pincode}
                      onChange={(e) => {
                        const value = e?.target?.value;


                        if (/^[a-zA-Z0-9 -]{0,5}$/.test(value)) {
                          setPincode(value);
                        }
                      }}
                      className={!isValidPinCode}
                      validationMessage={
                        !isValidPinCode ? "Please enter Valid Zip Code" : ""
                      }
                      required
                      width={"100%"}
                      onBlur={() => {

                        const validZipRegex = /^[a-zA-Z0-9 ]{5}$/;
                        setIsValidPinCode(validZipRegex.test(pincode));
                      }}
                      style={{ borderColor: !isValidPinCode ? "red" : "" }}

                    />
                  </Grid>
                </Grid>
                <div>
                  <div className="form-check mb-3"
                    style={{
                      marginTop: password.length && !(hasLowerCase && hasUpperCase && hasNumber && hasSpecialChar && isValidLength) ? "0px" : "3rem"
                    }}
                  >
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="termsCheckbox"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                      disabled={!areFieldsFilled()}
                    />
                    <label style={{ color: "#535353" }}>
                      By creating an account you agree to the
                      {/* Festival-Outfitter{" "} */}
                      <strong style={{ color: "#000000" }}>
                        {" "}
                        Festival-Outfitter
                      </strong>
                      <span className="fw-bold text-dark">
                        {" "}
                        Terms and Conditions
                      </span>
                      , and our{" "}
                      <span className="fw-bold text-dark">
                        Privacy Policy.
                      </span>
                    </label>
                  </div>
                </div>
                <div className="mb-2 mt-2">
                  <CustomButton
                    text="Create Account"
                    size="lg"
                    block={true}
                    className="mt-2"
                    onClick={handleRegister}
                    disabled={!validatePassword(password) || !email || !fullName || !phoneNumber || !pincode || !isChecked || !validPhone || isVerified || !isValidPinCode}
                  />
                </div>
                <div className="d-flex mt-3 align-items-center">
                  <hr className="flex-grow-1 me-4 text-secondary" />
                  <div
                    className=""
                    style={{
                      color: "#6C757D",
                      fontSize: "16px",
                      fontWeight: "400",
                    }}
                  >
                    or do it via other accounts
                  </div>
                  <hr className="flex-grow-1 ms-4 text-secondary" />
                </div>
                <div className="d-flex justify-content-center align-items-center mt-2">
                  <img
                    onClick={handleGoogleLogin}
                    src={google}
                    style={{ cursor: "pointer" }}

                    className="mr-5 cursor-pointer"
                  />
                  <img src={apple} className="mx-5 cursor-pointer" />
                  <img
                    onClick={onFacebookButtonPress}
                    src={facebook}
                    style={{ cursor: "pointer" }}
                  />
                </div>
                <p className="text-center fw-bold text-secondary mt-3">
                  Already have an account?{" "}
                  <Link to={`/events/${eventName}/login`} className="link-dark">
                    Login
                  </Link>
                </p>
              </form>
            </div>

          </div>
        </div>

      </section>
    </React.Fragment>
  );
};

export default Register;